// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard container */
.dashboard {
  display: flex;
 
  flex-direction: column; /* Topbar on top, Sidebar + Content below */
  height: 100%; /* Full viewport height */
  overflow: hidden; /* Prevent scrollbars outside the layout */
}

/* Topbar styles */

.conentcontainerdeisgn{
  background-color: #E8E9EA;
}

/* Content container (Sidebar + Main Content) */
.content-container {
  display: flex;
  border-radius: 5px;
  scrollbar-width: none; /* Hides scrollbar in Firefox */
  -ms-overflow-style: none;
  background-color: #ddd;
  flex: 1 1; /* Fills the remaining space below the Topbar */
  margin-bottom: 0px; /* Push Sidebar and Main Content below the Topbar */
  overflow: auto; /* Prevents overflow in the layout */
}

/* Sidebar styles */
.sidebar {
  
  width: 250px; /* Fixed width */
  background-color: white;
  overflow-y: auto; /* Sidebar scrolls if content overflows */
  scrollbar-width: none; /* Hides scrollbar in Firefox */
  -ms-overflow-style: none;
  /* height: calc(100vh - 60px); Full height minus Topbar height */
  position: sticky; /* Sticks in place during scrolling */
  top: 10px; /* Push below the Topbar */
  margin-top:0;
  z-index: 1; /* Keep Sidebar below the Topbar */
}


/* Main content styles */
.main-content {
  flex: 1 1; /* Main content takes the remaining space */
  /* overflow-y: auto; Enable scrolling for the main content */
  background-color: #ddd;
 
  height:0%; /* Full height minus Topbar height */
  box-sizing: border-box; /* Include padding in width/height */
}

.main-content h1{
  
  background-color: #ddd;
 
}

.Dashboarddesign
{
  height:85vh;
  padding: 0px;
  padding-top:10px;
 border-radius: 5px;
  background-color: white;
}
.Dashboard123
{

  height: auto;
  margin-top: 6%;
 padding: 0px;
  background-color:#E8E9EA;
}



/* ///////////////////////////////////////// */


@media screen and (max-width: 768px) {
  /* STACK CONTENT IN COLUMN */
  .content-container {
    flex-direction: column;
    width: 100%;
  }

  /* MAKE SIDEBAR ABSOLUTE TO AVOID SHIFTING CONTENT */
  .sidebar {
    position: relative;
    top: 0;
    left: 0;
    width: 50%;
    height: auto;
    background-color: white;
    display: none;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    /* transition: transform 0.3s ease-in-out; */
    /* transform: translateY(-100%); */
    margin-left: 0%;
    z-index: 100; /* Above overlay */
  }

  /* SHOW SIDEBAR WHEN TOGGLED */
  .sidebar.sidebar-open {
    transform: translateY(0);
  }

  .Dashboarddesign
  {
    height:100vh;
  padding: 0px;
  
 border-radius: 5px;
  background-color: white;
  }

  /* MAIN CONTENT FULL WIDTH */
  .main-content {
    width: 100%;
    flex: 1 1;
  }

  /* ADD SPACE IN TOPBAR FOR HAMBURGER */
  .topbar {
    margin-top: -20%;
    position: relative;
    padding-left: 30%;
    padding: 0;
    background-color: #001D4A;
  }
  .Dashboard123
{


  margin-top: -5%;
 padding: 0px;
  background-color:#E8E9EA;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;;EAEb,sBAAsB,EAAE,2CAA2C;EACnE,YAAY,EAAE,yBAAyB;EACvC,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA,kBAAkB;;AAElB;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB,EAAE,+BAA+B;EACtD,wBAAwB;EACxB,sBAAsB;EACtB,SAAO,EAAE,+CAA+C;EACxD,kBAAkB,EAAE,mDAAmD;EACvE,cAAc,EAAE,oCAAoC;AACtD;;AAEA,mBAAmB;AACnB;;EAEE,YAAY,EAAE,gBAAgB;EAC9B,uBAAuB;EACvB,gBAAgB,EAAE,yCAAyC;EAC3D,qBAAqB,EAAE,+BAA+B;EACtD,wBAAwB;EACxB,gEAAgE;EAChE,gBAAgB,EAAE,qCAAqC;EACvD,SAAS,EAAE,0BAA0B;EACrC,YAAY;EACZ,UAAU,EAAE,kCAAkC;AAChD;;;AAGA,wBAAwB;AACxB;EACE,SAAO,EAAE,2CAA2C;EACpD,4DAA4D;EAC5D,sBAAsB;;EAEtB,SAAS,EAAE,oCAAoC;EAC/C,sBAAsB,EAAE,oCAAoC;AAC9D;;AAEA;;EAEE,sBAAsB;;AAExB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;CACjB,kBAAkB;EACjB,uBAAuB;AACzB;AACA;;;EAGE,YAAY;EACZ,cAAc;CACf,YAAY;EACX,wBAAwB;AAC1B;;;;AAIA,8CAA8C;;;AAG9C;EACE,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA,oDAAoD;EACpD;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,0CAA0C;IAC1C,4CAA4C;IAC5C,kCAAkC;IAClC,eAAe;IACf,YAAY,EAAE,kBAAkB;EAClC;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,YAAY;EACd,YAAY;;CAEb,kBAAkB;EACjB,uBAAuB;EACvB;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,SAAO;EACT;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,yBAAyB;EAC3B;EACA;;;;EAIA,eAAe;CAChB,YAAY;EACX,wBAAwB;AAC1B;AACA","sourcesContent":["/* Dashboard container */\n.dashboard {\n  display: flex;\n \n  flex-direction: column; /* Topbar on top, Sidebar + Content below */\n  height: 100%; /* Full viewport height */\n  overflow: hidden; /* Prevent scrollbars outside the layout */\n}\n\n/* Topbar styles */\n\n.conentcontainerdeisgn{\n  background-color: #E8E9EA;\n}\n\n/* Content container (Sidebar + Main Content) */\n.content-container {\n  display: flex;\n  border-radius: 5px;\n  scrollbar-width: none; /* Hides scrollbar in Firefox */\n  -ms-overflow-style: none;\n  background-color: #ddd;\n  flex: 1; /* Fills the remaining space below the Topbar */\n  margin-bottom: 0px; /* Push Sidebar and Main Content below the Topbar */\n  overflow: auto; /* Prevents overflow in the layout */\n}\n\n/* Sidebar styles */\n.sidebar {\n  \n  width: 250px; /* Fixed width */\n  background-color: white;\n  overflow-y: auto; /* Sidebar scrolls if content overflows */\n  scrollbar-width: none; /* Hides scrollbar in Firefox */\n  -ms-overflow-style: none;\n  /* height: calc(100vh - 60px); Full height minus Topbar height */\n  position: sticky; /* Sticks in place during scrolling */\n  top: 10px; /* Push below the Topbar */\n  margin-top:0;\n  z-index: 1; /* Keep Sidebar below the Topbar */\n}\n\n\n/* Main content styles */\n.main-content {\n  flex: 1; /* Main content takes the remaining space */\n  /* overflow-y: auto; Enable scrolling for the main content */\n  background-color: #ddd;\n \n  height:0%; /* Full height minus Topbar height */\n  box-sizing: border-box; /* Include padding in width/height */\n}\n\n.main-content h1{\n  \n  background-color: #ddd;\n \n}\n\n.Dashboarddesign\n{\n  height:85vh;\n  padding: 0px;\n  padding-top:10px;\n border-radius: 5px;\n  background-color: white;\n}\n.Dashboard123\n{\n\n  height: auto;\n  margin-top: 6%;\n padding: 0px;\n  background-color:#E8E9EA;\n}\n\n\n\n/* ///////////////////////////////////////// */\n\n\n@media screen and (max-width: 768px) {\n  /* STACK CONTENT IN COLUMN */\n  .content-container {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  /* MAKE SIDEBAR ABSOLUTE TO AVOID SHIFTING CONTENT */\n  .sidebar {\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 50%;\n    height: auto;\n    background-color: white;\n    display: none;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    /* transition: transform 0.3s ease-in-out; */\n    /* transform: translateY(-100%); */\n    margin-left: 0%;\n    z-index: 100; /* Above overlay */\n  }\n\n  /* SHOW SIDEBAR WHEN TOGGLED */\n  .sidebar.sidebar-open {\n    transform: translateY(0);\n  }\n\n  .Dashboarddesign\n  {\n    height:100vh;\n  padding: 0px;\n  \n border-radius: 5px;\n  background-color: white;\n  }\n\n  /* MAIN CONTENT FULL WIDTH */\n  .main-content {\n    width: 100%;\n    flex: 1;\n  }\n\n  /* ADD SPACE IN TOPBAR FOR HAMBURGER */\n  .topbar {\n    margin-top: -20%;\n    position: relative;\n    padding-left: 30%;\n    padding: 0;\n    background-color: #001D4A;\n  }\n  .Dashboard123\n{\n\n\n  margin-top: -5%;\n padding: 0px;\n  background-color:#E8E9EA;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
